import React from 'react';
import ApplicationReportTable from './ApplicationReportTable';
import CustomerReportTable from './CustomerReportTable';
import DetailsReportTable from './DetailsReportTable';
import SummaryReportTable from './SummaryReportTable';

function ReportTable({ reportType }) {
    switch (reportType) {
        case 'summary':
            return <SummaryReportTable />;
        case 'details':
            return <DetailsReportTable />;
        case 'application':
            return <ApplicationReportTable />;
        case 'customer':
            return <CustomerReportTable />;
        default:
            break;
    }
}

export default ReportTable;
